import React from 'react'
import { Container, Header, Image, Button } from 'semantic-ui-react'
import Link from 'gatsby-link';
import Fade from 'react-reveal/Fade'
import '../styles/aboutSection.scss';
import aboutImage from '../images/about.jpg';
import pmenaLogo from '../images/about2.png';

const aboutStyles = {
  background: `linear-gradient(to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.7)),
    url('${aboutImage}')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat:'no-repeat',

};

const AboutSection = () => (
  <section id='about' className="content-deck about" style={aboutStyles}>
    <Container>
      {/* <Image src={pmenaLogo}/> */}
      <Fade right>

        <div className="about__content">
          <h3>About</h3>
          <p>
            <span className='about__lead-text'>Join us
            for the 40th Annual Conference of the North American Chapter of the International Group
            for the Psychology of Mathematics Education (<a target="_blank" href="http://www.pmena.org/">PME - NA</a>) in Greenville, South Carolina!</span>
              <br/><br/>
            As part of our celebration of 40 years of PME-NA, this year’s conference will focus on enduring challenges in mathematics education research and look ahead to emerging opportunities in the field. Plenary sessions will address our major conference themes: mathematical and pedagogical demands
            for P-16 education, equitable mathematics teaching and research, leveraging new technologies, and perspectives on the nature of mathematics and research. The program will also feature a variety of excellent research reports, brief research reports, and posters submitted by the PME-NA community, as well as numerous opportunities to collaborate and socialize with mathematics education colleagues.
          </p>
          <Button size="medium" inverted color="teal" className="about__button"><Link to='about'>Learn More</Link></Button>

        </div>
      </Fade>
    </Container>
  </section>
)

export default AboutSection;


// WEBPACK FOOTER //
// ./src/sections/aboutSection.js